module.exports = __webpack_public_path__ + "imgs/pin.2ef59570af5c1ea659a93cf665ef083d.svg";